import { useEffect, useState } from "react"
import { ServerUnlockAmountInfo } from "../../data/common"
import Api from "../../utils/Api"
import { AppEvent, AppMessageType } from "../../data/events"
import events from "../../utils/events"
import Table, { ColumnsType, TablePaginationConfig } from "antd/es/table"
import moment from "moment"
import { ConfigProvider, Dropdown } from "antd"
import CheckPayoutModal from "./CheckPayoutModal"
import { StyleUtils } from "../../utils/Style"
import { AntdTable } from "../../views/commonview"
import { WorkInfoManager } from "../../utils/WorkData"
import { UserInfoManager } from "../../utils/UserInfoManager"
import { GlobalUtil } from "../../utils/GlobalText"


interface UnlockAmountTableProps {
  shareUrl: string
}
export const UnlockAmountTableView: React.FC<UnlockAmountTableProps> = (props) => {
  const [data, setData] = useState<ServerUnlockAmountInfo[]>([])
  const [tableParams, setTableParams] = useState<TablePaginationConfig>({
    current: 1,
    pageSize: 10,
  });
  const loadData = async () => {
    try {
      let res = await Api.getUnlockAmountList(props.shareUrl,tableParams.current,tableParams.pageSize)
      if (res.code) {
        setTableParams({
          ...tableParams,
          total: res.data?.total,
        });
        setData(res.data?.records ?? [])
      }
    } catch (error) {

    }

  }
  const [update, setUpdate] = useState(false)
  const handleTableChange = (
    pagination: TablePaginationConfig,
  ) => {
    setTableParams(pagination);

    // `dataSource` is useless since `pageSize` changed
    if (pagination.pageSize !== tableParams?.pageSize) {
      setData([]);
    }
  };
  useEffect(() => {
    loadData();
  }, [JSON.stringify(tableParams)]);

  events.on(AppEvent.REFRES, () => {
    setUpdate(!update)
  })
  useEffect(() => {
    loadData()
  }, [update])
  const columns: ColumnsType<ServerUnlockAmountInfo> = [
    {
      title: GlobalUtil.t("income.releaseDay"),
      dataIndex: 'releaseDay',
      render: (value: number) => {
        return <div style={{ fontSize: "0.88rem", color: StyleUtils.theme().fontColor_1, fontWeight: "400" }}>
          {moment(value).format('YYYY-MM-DD')}
        </div>
      }
    },
    {
      title: GlobalUtil.t("income.lockAmount"),
      dataIndex: "lockAmount",
      render(value, record, index) {
        return <div style={{ fontSize: "0.88rem", color: StyleUtils.theme().fontColor_1, fontWeight: "400" }}>
          {value} {UserInfoManager.getShowCurrency()}
        </div>
      },
    },
    {
      title: GlobalUtil.t("income.isUnlock"),
      dataIndex: "isUnlock",
      render(value, record, index) {
        let status = ""
        if (record.isUnlock === 1) {
          status = GlobalUtil.t("income.unlockSuccess")
        } else {
          status = GlobalUtil.t("income.unlockWait")
        }
        return <div style={{ width: "100%", display: "flex", flexDirection: "row" }}>
          <div style={{ fontSize: "0.88rem", color: StyleUtils.theme().fontColor_1, fontWeight: "400" }}>{status}</div>
        </div>
      },
    },
    {
      title: GlobalUtil.t("income.createTime"),
      dataIndex: "createTime",
      render(value, record, index) {
        return <div style={{ width: "100%", display: "flex", flexDirection: "row" }}>
          <div style={{ fontSize: "0.88rem", color: StyleUtils.theme().fontColor_1, fontWeight: "400" }}>{moment(value).format('YYYY-MM-DD')}</div>
        </div>
      },
    }
  ];
  return <div style={{ width: "100%", paddingTop: WorkInfoManager.shareUrl ? "1rem" : "0rem", background: StyleUtils.theme().boardBg }}>
    <AntdTable>
      <Table
        pagination={tableParams}
        onChange={handleTableChange}
        className={StyleUtils.isLight ? "tableD" : "tableL"}
        style={{ borderRadius: WorkInfoManager.shareUrl ? "0" : "", marginLeft: WorkInfoManager.shareUrl ? StyleUtils.getWidth(12) : 0, marginRight: WorkInfoManager.shareUrl ? StyleUtils.getWidth(12) : 0 }}
        columns={columns}
        dataSource={data}
      />
    </AntdTable>
  </div>
}